import { render, staticRenderFns } from "./ScoringProfilesModelsList.vue?vue&type=template&id=55cac40c"
import script from "./ScoringProfilesModelsList.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesModelsList.vue?vue&type=script&lang=js"
import style0 from "./ScoringProfilesModelsList.vue?vue&type=style&index=0&id=55cac40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports